import React from "react";
import { Button } from "@sscs/ui";
import { EditIcon, VisibilityIcon } from "@sscs/ui/icons";
import { getClassName } from "@sscs/utils";
import { EDITOR_MODE, EditorMode } from "../utils";
import styles from "./editorCard.module.scss";

type EditorCardProps = {
  title: React.ReactNode;
  subtitle: React.ReactNode;
  editorMode: EditorMode;
  editor: React.ReactNode;
  preview: React.ReactNode;
  isDirty: boolean;
  onDiscard: () => void;
  onSave: () => void;
};

const EditorCard = ({
  title,
  subtitle,
  editorMode,
  editor,
  preview,
  isDirty,
  onDiscard,
  onSave,
}: EditorCardProps): React.JSX.Element => {
  const showEdit =
    editorMode === EDITOR_MODE.edit || editorMode === EDITOR_MODE.split;
  const showPreview =
    editorMode === EDITOR_MODE.preview || editorMode === EDITOR_MODE.split;

  return (
    <div
      className={getClassName(styles["edit-or-preview"], {
        [styles["unsaved-changes"]]: isDirty,
        [styles["split-mode"]]: editorMode === EDITOR_MODE.split,
      })}
    >
      <div
        className={getClassName(styles["title-container"], {
          [styles["unsaved-changes"]]: isDirty,
        })}
      >
        <div>
          <div>
            {title}
            {isDirty && (
              <span className={styles["unsaved-changes-label"]}>
                Unsaved changes
              </span>
            )}
          </div>
          <div className={styles.subtitle}>{subtitle}</div>
        </div>
        {isDirty && (
          <div className={styles.actions}>
            <Button color="secondary" isInline onClick={onDiscard}>
              Discard
            </Button>
            <Button onClick={onSave} isInline>
              Save
            </Button>
          </div>
        )}
      </div>
      {showEdit && (
        <div className={styles["segment-title"]}>
          <EditIcon size="xs" />
          Editor
        </div>
      )}
      {showPreview && (
        <div className={styles["segment-title"]}>
          <VisibilityIcon size="xs" />
          Preview
        </div>
      )}
      {showEdit ? editor : null}
      {showPreview ? preview : null}
    </div>
  );
};

export default EditorCard;
